import { changeEnvUrl, getAppEnv } from '@common/assets/ts/utils';
import { apiMap } from '@common/assets/ts/const';
import { useStoreCommon } from '@common/store/common';
import Vue from 'vue';
import { FreereaderRequest, IOptionsConfig, IRetryConfig } from '@q-front-npm/request';
const isDev = import.meta.env.VITE_ENV === 'dev';
const isProd = import.meta.env.VITE_ENV === 'production';
const isTest = import.meta.env.VITE_ENV === 'test';
const retryingUrl: string[] = [];
// 当前debug包所处环境
const testEnv = getAppEnv();
const requestConfig: IOptionsConfig = {
    isDev,
    apiMap,
    toastFn: (msg: string) => {
        Vue.prototype.$toast(msg);
    },
    withCredentials: true, // 低版本（不支持jsb获取header）必须携带cookie, 跳转中间页自动登录 `${window.location.origin}/app-h5/activity/freereaderCommonLogin?full_screen=3`
    useJsb: false,
    isCrypt: false,
    timeout: 10000,
    requestInterceptors: async(config: Record<string, any>) => {
        const storeCommon = useStoreCommon();
        if (isDev || isTest) {
            config.params = { ...config.params, test_uid: storeCommon.urlParams.uid, };
        }
        // 只有在debug包中客户端才会加入test-env头部字段test-env
        if (testEnv && !isProd) {
            // 添加header头标识哪个环境
            config.headers = {
                ...config.headers,
                'test-env': testEnv,
            };
            const reg = /^http[\s\S]+/;
            // 无域名请求（直接以当前域名为baseURL请求）
            if (reg.test(config.url || '') || reg.test(config.baseURL || '')) {
                config.baseURL = changeEnvUrl(config.baseURL || '');
                config.url = changeEnvUrl(config.url || '');
            }
        }
        return config;
    },
    responseInterceptors: (res: Record<string, any>) => {
        console.log('-- res', res);
        const storeCommon = useStoreCommon();
        storeCommon.setPageLoading(false);
        const { errors, } = res.data;
        if (errors) {
            return Promise.reject(res);
        }
        return res.data;
    },
    requestInterceptorsError: (err: any) => {
        console.log('-- request error', err);
        return Promise.reject(err);
    },
    responseInterceptorsError: (err: any) => {
        console.log('-- response error', err);
        const storeCommon = useStoreCommon();
        storeCommon.setPageLoading(false);
        return Promise.reject(err);
    },
    retrying: (config: IRetryConfig) => {
        const inRetryingUrl = retryingUrl.some((url) => (config?.url || '').indexOf(url) > -1);
        if (inRetryingUrl) {
            console.log('-- retrying', config.retryEnd, config.isSuccess);
        }
    },
};

const request = new FreereaderRequest(requestConfig);

export const get = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.get(url, params, config);
};

export const post = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.post(url, params, config);
};

export const postForm = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.postForm(url, params, config);
};
